import React, { useState, useEffect, useContext } from "react";
import "popper.js";
import "bootstrap/dist/js/bootstrap";
import { useHistory } from 'react-router-dom';
// Componentes
import Foto from "../element/Foto";
import HeaderMenu from "../element/HeaderMenu";
import Menu from "./Menu";
// Contexto
import dataContext from "../context/User";
// Helper
import GetFetchDTE from "../helper/GetFetchDTE";
import loadMenu from "../js/main";
import Footer from './Footer';
import DtesView from "../element/DtesViewAlumnos";
import SkeletonCard from "../element/Skeleton";
import EmptyState from "../element/EmptyState";


const DtesAlumnos = () => {
    const history = useHistory();
    const dataUser = useContext(dataContext);
    let datos = localStorage.getItem('dataUser');
    const [dtes, setDtes] = useState([]);
    const [cargando, setCargando] = useState(true);
    if (datos) {
        let cred = JSON.parse(datos);
        dataUser.token = cred.token;
        dataUser.nombre = cred.nombre;
        dataUser.carnet = cred.carnet;
    } else {
        history.push("/");
    }

    useEffect(() => {
        loadMenu();
        const dormData = { "carnet": dataUser.carnet, "secret": "5ec4702eff406849a82818cb"}
        GetFetchDTE.alumnoHistoria(dormData).then(dataDTE => {
            if (dataDTE.hasOwnProperty('success') && dataDTE.success === 1) {
                setDtes(dataDTE.result);

                // Marca todas las facturas vistas para que el aviso "factura
                // nueva" del dashboard se limpie al revisarlas aquí.
                const codigos = (Array.isArray(dataDTE.result) ? dataDTE.result : [])
                    .map((el) => el && el.mh && (el.mh.codigo_generacion || el.mh.CodigoGeneracion))
                    .filter(Boolean);
                const vistos = JSON.parse(localStorage.getItem('dteFacturasVistas_v2') || '[]');
                const union = Array.from(new Set([...vistos, ...codigos]));
                localStorage.setItem('dteFacturasVistas_v2', JSON.stringify(union));
            }
            setCargando(false);
        }).catch(() => setCargando(false))
    }, [datos, history]);

    return (
        <div className="wrapper d-flex align-items-stretch">
            <nav id="sidebar">
                <div className="custom-menu">
                    <button
                        type="button"
                        id="sidebarCollapse"
                        className="btn btn-primary"
                    >
                        <i className="fa fa-bars"></i>
                        <span className="sr-only">Toggle Menu</span>
                    </button>
                </div>
                <div className="p-4">
                    <Foto foto={dataUser.carnet} alt="Foto alumno" tamanio="rounded" />

                    <HeaderMenu
                        carnet={dataUser.carnet}
                        nombre={dataUser.nombre}
                        posicion="text-center"
                    />

                    <Menu />

                    <Footer />
                </div>
            </nav>


            <div id="content" className="p-4 p-md-5 pt-5">
                <h2 className="mb-4">Facturas: cuotas y otros pagos</h2>
                <p className="text-muted">Consulta de los pagos que has realizado.</p>

                {
                    cargando
                        ? <SkeletonCard rows={5} />
                        : dtes.length > 0
                            ? <DtesView data={dtes} />
                            : (
                                <EmptyState icon="fa-file-text-o" title="Aún no hay facturas">
                                    Cuando realices un pago, tu factura electrónica aparecerá aquí.
                                </EmptyState>
                            )
                }
            </div>
        </div>
    )
}

export default DtesAlumnos
